import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StudentRoomView from './StudentRoomView';
import SupervisorDashboard from './SupervisorDashboard';
import { SocketProvider } from '../context/SocketContext';

const ExamRoom = () => {
  const { userId, role, roomId } = useParams();
  const [isValidParams, setIsValidParams] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Validate parameters
    if (!userId || !role || !roomId) {
      setError('Parameter URL tidak lengkap');
      return;
    }

    if (!['student', 'supervisor'].includes(role)) {
      setError('Role harus "student" atau "supervisor"');
      return;
    }

    if (userId.length < 3 || roomId.length < 3) {
      setError('User ID dan Room ID minimal 3 karakter');
      return;
    }

    setIsValidParams(true);
  }, [userId, role, roomId]);

  if (!isValidParams) {
    return (
      <div className="min-h-screen bg-red-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full border-l-4 border-red-500">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0">
              <svg className="h-6 w-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="ml-3 text-lg font-semibold text-red-800">Error Parameter</h2>
          </div>
          <p className="text-red-700 mb-4">{error}</p>
          <div className="text-sm text-gray-600">
            <p className="font-semibold mb-2">Format yang benar:</p>
            <code className="bg-gray-100 px-2 py-1 rounded">
              /{'{user_id}'}/{'{role}'}/{'{room_id}'}
            </code>
            <div className="mt-3">
              <p className="font-semibold">Contoh:</p>
              <ul className="mt-1 space-y-1 text-xs">
                <li>• /student001/student/room-A1</li>
                <li>• /supervisor01/supervisor/room-A1</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <SocketProvider userId={userId} role={role} roomId={roomId}>
      <div className="min-h-screen bg-gray-900">
        {/* Header */}
        <header className="bg-gray-800 shadow-sm border-b border-gray-700">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center space-x-4">
                <h1 className="text-xl font-semibold text-white">
                  Ujian Online
                </h1>
                <span className="text-sm text-gray-300">
                  Room: {roomId}
                </span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                  <div className={`w-2 h-2 rounded-full ${role === 'student' ? 'bg-blue-500' : 'bg-green-500'}`}></div>
                  <span className="text-sm text-gray-300">
                    {role === 'student' ? 'Peserta' : 'Pengawas'}: {userId}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="h-[calc(100vh-4rem)]">
          {role === 'student' ? (
            <StudentRoomView userId={userId} roomId={roomId} />
          ) : (
            <SupervisorDashboard userId={userId} roomId={roomId} />
          )}
        </main>
      </div>
    </SocketProvider>
  );
};

export default ExamRoom;